'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    VeranstaltungResource = _require2.VeranstaltungResource;

module.exports.Veranstaltung = function (_BaseEntity) {
  _inherits(Veranstaltung, _BaseEntity);

  _createClass(Veranstaltung, null, [{
    key: '__name__',
    value: function __name__() {
      return 'veranstaltung';
    }
  }]);

  function Veranstaltung(data) {
    _classCallCheck(this, Veranstaltung);

    var _this = _possibleConstructorReturn(this, (Veranstaltung.__proto__ || Object.getPrototypeOf(Veranstaltung)).call(this));

    _this._entityName = 'de.ul.fob.domain.Veranstaltung';
    _this.name = null;
    _this.relevantFuerWeitere = false;
    _this.veranstaltungEnde = null;
    _this.veranstaltungStart = null;
    _this.veranstaltungsTyp = null;
    _this.beschreibungDE = null;
    _this.beschreibungEN = null;
    _this.externeWebsite = null;
    _this.stadt = null;
    _this.virtuell = false;

    _this.land = null;
    _this.organisationseinheit = null;
    _this.veranstalter = null;
    _this.weitereOrganisationseinheiten = null;
    _get(Veranstaltung.prototype.__proto__ || Object.getPrototypeOf(Veranstaltung.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Veranstaltung, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'name', 'relevantFuerWeitere', 'veranstaltungEnde', 'veranstaltungStart', 'veranstaltungsTyp', 'beschreibungDE', 'beschreibungEN', 'externeWebsite', 'stadt', 'virtuell'],
        links: ['organisationseinheit', 'veranstalter', 'weitereOrganisationseinheiten', 'land']
      });
    }
  }, {
    key: 'fetchOrganisationseinheit',
    value: function fetchOrganisationseinheit() {
      return _get(Veranstaltung.prototype.__proto__ || Object.getPrototypeOf(Veranstaltung.prototype), 'genericResolve', this).call(this, 'organisationseinheit');
    }
  }, {
    key: 'fetchVeranstalter',
    value: function fetchVeranstalter() {
      return _get(Veranstaltung.prototype.__proto__ || Object.getPrototypeOf(Veranstaltung.prototype), 'genericResolve', this).call(this, 'veranstalter');
    }
  }, {
    key: 'fetchWeitereOrganisationseinheiten',
    value: function fetchWeitereOrganisationseinheiten() {
      return _get(Veranstaltung.prototype.__proto__ || Object.getPrototypeOf(Veranstaltung.prototype), 'genericResolve', this).call(this, 'weitereOrganisationseinheiten');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Veranstaltung.prototype.__proto__ || Object.getPrototypeOf(Veranstaltung.prototype), 'genericResolve', this).call(this, 'organisationseinheit'), _get(Veranstaltung.prototype.__proto__ || Object.getPrototypeOf(Veranstaltung.prototype), 'genericResolve', this).call(this, 'veranstalter'), _get(Veranstaltung.prototype.__proto__ || Object.getPrototypeOf(Veranstaltung.prototype), 'genericResolve', this).call(this, 'weitereOrganisationseinheiten'), _get(Veranstaltung.prototype.__proto__ || Object.getPrototypeOf(Veranstaltung.prototype), 'genericResolve', this).call(this, 'land')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof VeranstaltungResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Veranstaltung.prototype.__proto__ || Object.getPrototypeOf(Veranstaltung.prototype), 'fetchQuery', this).call(this, VeranstaltungResource);
      }
    }
  }]);

  return Veranstaltung;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/veranstaltung.js
// module id = bSe0
// module chunks = 0